<footer>
  <span>{{rights_reserve}}</span>
</footer>